
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Comment utiliser les annonces dynamiques Google Ads - ALEO",
    description:
      "Dans ce guide, apprenez à utiliser les annonces dynamiques Google Ads avec ALEO pour améliorer votre visibilité grâce à un ciblage automatisé et pertinent.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
